import { DecimalPipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, forwardRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

const CUSTOM_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => PercentTextInputComponent),
  multi: true,
};

@Component({
    selector: 'odq-percent-text-input',
    providers: [CUSTOM_VALUE_ACCESSOR],
    templateUrl: './percent-text-input.component.html',
    styleUrls: ['./percent-text-input.component.scss'],
    standalone: false
})
export class PercentTextInputComponent implements ControlValueAccessor, OnDestroy {

  @ViewChild('inputField', { static: true })
  inputField: ElementRef;

  @Input() badge;

  private subject$ = new Subject();

  public disabled: boolean;

  // tslint:disable-next-line: ban-types
  private onTouched: Function;
  destroy$ = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef, private decimalPipe: DecimalPipe) {
    this.onTouched = () => { };
    this.disabled = false;

    this.subject$.pipe(
      debounceTime(600),
      distinctUntilChanged(),
      takeUntil(this.destroy$),
    ).subscribe(this.handleInputEvent.bind(this));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeCallback = (data: any) => { };
  touchCallback = () => { };

  onChange($event) {
    this.subject$.next($event);
  }

  private handleInputEvent($event) {
    let value = Number($event.target.value);
    value = value > 100 ? 100 : value;
    const inputValue = this.decimalPipe.transform(value, '1.0-10');
    this.inputField.nativeElement.value = inputValue;
    this.changeCallback(inputValue);
  }

  writeValue(obj: any): void {
    let value = Number(obj);
    value = value > 100 ? 100 : value;
    const inputValue = this.decimalPipe.transform(value, '1.0-10');
    this.inputField.nativeElement.value = inputValue;
  }

  registerOnChange(fn: any) {
    this.changeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.touchCallback = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
